module.exports = __webpack_public_path__ + "img/1-12-6.8d4c2496.png";